module.exports = __webpack_public_path__ + "static/img/s3.01b1a22c.png";